document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[js-marquee-wrapper]').forEach(element => {
		setInterval(() => {
			if (element.scrollLeft + element.clientWidth >= element.scrollWidth) {
				element.scrollTo(0, 0);
			} else {
				element.scrollTo(element.scrollLeft + 1, 0);
			}
		}, 10);
	});

	document.querySelectorAll('[js-tab]').forEach(element => {
		element.addEventListener('click', () => {
			const container = element.closest('[js-container]');
			if (!container) return;
			container.querySelector('.active[js-tab]').classList.remove('active');
			container.querySelector('.active[js-tab-element]').classList.remove('active');
			element.classList.add('active');
			container.querySelector(`[js-tab-element][data-id="${element.getAttribute('data-id')}"]`).classList.add('active');
		});
	});

	setTimeout(()=>{
		document.querySelectorAll('[js-tab-element]+[js-tab-element]').forEach(element => {
			element.classList.remove('active');
		});
	});

	document.querySelectorAll('.section-video video').forEach(element => {
		element.addEventListener('click', () => {
			if (element.paused) element.play();
			else element.pause();
		});
	});
	document.querySelectorAll('.sec__video div:has(>video)').forEach(element => {
		element.addEventListener('click', () => {
			const video = element.querySelector('video');
			if (!video) return;
			if (video.paused) {
				video.play();
				element.classList.add('playing');
			}
			else {
				video.pause();
				element.classList.remove('playing');
			}
		});
	});
});


/* =========================================================
   HUB PAGE - STICKY NAVIGATION
========================================================= */

document.addEventListener('DOMContentLoaded', () => {
	const hubPage = document.querySelector('.hub-page');

	if (!hubPage) return;

	const hero = hubPage.querySelector('.hub-page__hero');
	const stickyNav = hubPage.querySelector('.hub-sticky-nav');
	const navLinks = hubPage.querySelectorAll('.hub-sticky-nav__link');
	const article = hubPage.querySelector('.hub-article');

	if (!stickyNav || !hero) return;


	/* ---------------------------------------------------------
	   1. CREATE IDs FOR RICHTEXT HEADINGS
	--------------------------------------------------------- */

	if (article) {
		const headings = article.querySelectorAll('h2, h3, h4');

		headings.forEach((heading) => {
			const text = heading.textContent
				.trim()
				.toUpperCase()
				.replace(/\s+/g, ' ');

			if (text.includes('VINTAGE OR MODERN')) {
				heading.id = 'vintage-modern';
				heading.classList.add('hub-scroll-target');
			}

			if (text.includes('BUYING VINTAGE')) {
				heading.id = 'buying-vintage';
				heading.classList.add('hub-scroll-target');
			}
		});
	}


	/* ---------------------------------------------------------
	   2. SHOW HUB NAV ONLY AFTER HERO
	--------------------------------------------------------- */

	const updateStickyNavVisibility = () => {
		const heroRect = hero.getBoundingClientRect();

		if (heroRect.bottom <= 0) {
			stickyNav.classList.add('is-visible');
		} else {
			stickyNav.classList.remove('is-visible');
		}
	};


	/* ---------------------------------------------------------
	   3. POSITION HUB NAV UNDER VISIBLE SITE HEADER
	--------------------------------------------------------- */

	const updateStickyNavPosition = () => {
	if (!stickyNav.classList.contains('is-visible')) {
		stickyNav.style.top = '';
		return;
	}

	/*
	 * Find all possible visible Soundgas header elements.
	 * When scrolling UP, Shopify reveals the header again.
	 * We take the lowest visible bottom edge and position
	 * the Hub nav directly underneath it.
	 */
	const headerElements = document.querySelectorAll(
		'.shopify-section-group-header-group, ' +
		'.section-header, ' +
		'sticky-header, ' +
		'.header-wrapper'
	);

	let visibleHeaderBottom = 0;

	headerElements.forEach((element) => {
		const rect = element.getBoundingClientRect();

		const isVisible =
			rect.height > 0 &&
			rect.bottom > 0 &&
			rect.top < window.innerHeight;

		if (!isVisible) return;

		visibleHeaderBottom = Math.max(
			visibleHeaderBottom,
			rect.bottom
		);
	});

	/*
	 * Prevent unrelated large containers from creating
	 * an excessive offset.
	 */
	visibleHeaderBottom = Math.min(
		Math.max(visibleHeaderBottom, 0),
		220
	);

	stickyNav.style.top = `${visibleHeaderBottom}px`;

	const stickyNavBottom =
		stickyNav.classList.contains('is-visible')
			? visibleHeaderBottom + stickyNav.offsetHeight
			: 0;

		document.documentElement.style.setProperty(
		'--hub-sidebar-top',
		`${stickyNavBottom + 16}px`
		);
};


	/* ---------------------------------------------------------
	   4. SMOOTH SCROLL
	--------------------------------------------------------- */

	navLinks.forEach((link) => {
		link.addEventListener('click', (event) => {
			const targetId = link.dataset.hubTarget;
			const target = document.getElementById(targetId);

			if (!target) return;

			event.preventDefault();

			const navHeight = stickyNav.offsetHeight || 58;

			const header =
				document.querySelector('.shopify-section-group-header-group') ||
				document.querySelector('header');

			let headerHeight = 0;

			if (header) {
				const headerRect = header.getBoundingClientRect();

				if (headerRect.bottom > 0) {
					headerHeight = Math.max(0, headerRect.bottom);
				}
			}

			const extraGap = 18;

			const targetPosition =
				target.getBoundingClientRect().top +
				window.pageYOffset -
				navHeight -
				headerHeight -
				extraGap;

			window.scrollTo({
				top: targetPosition,
				behavior: 'smooth'
			});

			navLinks.forEach((item) => {
				item.classList.remove('is-active');
			});

			link.classList.add('is-active');
		});
	});


	/* ---------------------------------------------------------
	   5. ACTIVE NAV ITEM WHILE SCROLLING
	--------------------------------------------------------- */

	const trackedTargets = [
		'about',
		'vintage-modern',
		'buying-vintage',
		'author',
		'faqs',
		'explore',
		'related'
	];

	const updateActiveSection = () => {
		const navHeight = stickyNav.offsetHeight || 58;

		const header =
			document.querySelector('.shopify-section-group-header-group') ||
			document.querySelector('header');

		let headerHeight = 0;

		if (header) {
			const headerRect = header.getBoundingClientRect();

			if (headerRect.bottom > 0) {
				headerHeight = Math.max(0, headerRect.bottom);
			}
		}

		const activationPoint = headerHeight + navHeight + 40;

		let currentSection = 'about';
		let closestTop = -Infinity;

		trackedTargets.forEach((id) => {
			const section = document.getElementById(id);

			if (!section) return;

			const rect = section.getBoundingClientRect();

			if (
				rect.top <= activationPoint &&
				rect.top > closestTop
			) {
				closestTop = rect.top;
				currentSection = id;
			}
		});

		navLinks.forEach((link) => {
			link.classList.toggle(
				'is-active',
				link.dataset.hubTarget === currentSection
			);
		});
	};


	/* ---------------------------------------------------------
	   6. RUN ON SCROLL
	--------------------------------------------------------- */

	let ticking = false;

	const handleScroll = () => {
		if (ticking) return;

		ticking = true;

		window.requestAnimationFrame(() => {
			updateStickyNavVisibility();
			updateStickyNavPosition();
			updateActiveSection();

			ticking = false;
		});
	};

	window.addEventListener('scroll', handleScroll, {
		passive: true
	});

	window.addEventListener('resize', () => {
		updateStickyNavVisibility();
		updateStickyNavPosition();
		updateActiveSection();
	});


	/* ---------------------------------------------------------
	   7. INITIAL RUN
	--------------------------------------------------------- */

	updateStickyNavVisibility();
	updateStickyNavPosition();
	updateActiveSection();
});